import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import TimelineTemplate from './TimelineTemplate';
import ProcessFlowTemplate from './ProcessFlowTemplate';
import ComparisonTableTemplate from './ComparisonTableTemplate';
import BarChartTemplate from './BarChartTemplate';
import './TemplateVisualizer.css';

const TEMPLATE_COMPONENTS = {
  timeline: TimelineTemplate,
  process_flow: ProcessFlowTemplate,
  comparison_table: ComparisonTableTemplate,
  bar_chart: BarChartTemplate,
};

const TemplateVisualizer = ({ templateData }) => {
  if (!templateData) return null;

  const { template, title, subject, params } = templateData;
  const TemplateComponent = TEMPLATE_COMPONENTS[template];

  if (!TemplateComponent) {
    return (
      <div className="template-visualizer" data-subject={subject}>
        <p style={{ color: 'var(--panel-text-secondary)' }}>
          Template "{template}" is not available yet.
        </p>
      </div>
    );
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        className="template-visualizer"
        data-subject={subject}
        key={`${template}-${title}`}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -16 }}
        transition={{ duration: 0.3, ease: [0.32, 0.72, 0, 1] }}
      >
        <div className="template-visualizer__subtitle">
          {subject}
        </div>
        <h2 className="template-visualizer__title">{title}</h2>
        <TemplateComponent params={params} subject={subject} />
      </motion.div>
    </AnimatePresence>
  );
};

export default TemplateVisualizer;
